document.documentElement.classList.remove('no-js');
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-menu-toggle]');
  if (toggle) {
    const nav = document.querySelector('[data-mobile-nav]');
    if (nav) nav.classList.toggle('is-open');
  }
});
